import { useTranslator } from '@gandi/translate';
import { Button } from '@gandi/ui';
import { useAppSelector } from '../../../../hooks/useAppSelector';
import { selectCountItems } from '../../modules/selectors';
import { jsx as _jsx } from "react/jsx-runtime";
var styles = {
  "deleteButton": "DeletionButton-deleteButton_hVLro"
};
export function DeletionButton({
  isDeleting,
  setConfirmDeleteCart
}) {
  const {
    __
  } = useTranslator();
  const count = useAppSelector(selectCountItems);
  const canDeleteCart = count > 0;
  if (!canDeleteCart) return null;
  return /*#__PURE__*/_jsx(Button, {
    iconBefore: "trash",
    kind: "ghost",
    onClick: () => setConfirmDeleteCart(true),
    loading: isDeleting,
    className: styles.deleteButton,
    children: __('Clear')
  });
}